import { render, staticRenderFns } from "./ConfirmMobileToken.vue?vue&type=template&id=f4decd04&"
import script from "./ConfirmMobileToken.vue?vue&type=script&lang=js&"
export * from "./ConfirmMobileToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports